import gql from "graphql-tag";
export const siteListQuery = `query($where:JSON,$last: Int, $first: Int){
  allSites (where:$where,last: $last, first: $first){
      totalCount
    Sites {
      approvalstatus
      name
      siteid
      id
      sitecityrel {
        Cities {
          id
          name
        }
      }
      sitecountryrel {
        Countries {
          id
          name
        }
      }
      mappedSite{
        Usersitemaps{
          mappeduserrel{
            Userdata{
              firstname
              lastname
              id
              role
            }
          }
        }
      }
    }
  }
}`;

export const addSiteQuery = gql`
  mutation saveSite($obj: SiteInput!) {
    saveSite(obj: $obj) {
      id
    }
  }
`;
export const getSiteEditData = (id) => `{
  allSites (where:{active:"1",id:${id}}){
    Sites {
      approvalstatus
      address1
      address2
      zipcode
      name
      siteid
      id
       sitecityrel {
        Cities {
          id
          name
        }
      }
      sitecountryrel {
        Countries {
          id
          name
        }
      }
      sitestaterel {
        States {
          id
          name
        }
      }
       PaSiteMap (where:{active:1}){
        Siteemails {
          id
          type
          toorcc
          userid
          siteid
          pasiteuserrel {
            Userdata {
              id
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}`;
export const siteCountryData = `query{
  
  allUserdata(where:{order:"firstname asc",active:1}){
    Userdata{
      id
      firstname
      lastname
    }
  }
}`;
export const siteStateData = `query($where:JSON){
  allStates(where:$where){
    States{
      countryid
      id
      name
    }
  }
}`;
export const siteCityData = `query($where:JSON){
  allCities (where:$where){
    Cities {
      id
      name
      stateid
    }
  }
}`;
export const siteListDropDownData = `query{
  allCountries(where: {order: "name asc"}) {
    Countries {
      id
      name
      shortname
      StateCountry {
        States {
          id
          CityState {
            Cities {
              id
              name
            }
          }
        }
      }
    }
  }
  allCities(where: {order: "name asc"}) {
    Cities {
      id
      name
      stateid
    }
  }
  allUserdata(where: {active: 1, role: "SALESREP"}) {
    Userdata {
      id
      firstname
      lastname
      mappedUser(where: {active: 1}) {
        Usersitemaps {
          siteid
          id
          active
          mappedsiterel {
            Sites {
              name
              id
            }
          }
        }
      }
    }
  }
}`;

export const siteEmailQuery = gql`
  mutation saveSiteemails($obj: SiteemailsInput!) {
    saveSiteemails(obj: $obj) {
      id
    }
  }
`;

export const siteCountry = `query($where:JSON){allCountries(where:$where){
    Countries{
      id
      name
      shortname
    }
  }}`;
export const siteUserdata = `query($where:JSON){
    allUserdata(where:$where){
      Userdata{
        id
        firstname
        lastname
        mappedUser(where:{active:1}){
          Usersitemaps{
            siteid
            id
            active
            mappedsiterel{
              Sites{
                name
                id
              }
            }
          }
      }
      }
    }
  }`;
